import { useCallback } from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useModal } from 'modules/taboola-common-frontend-modules/modals';

export const useMyAudiencesDefaultExcludeModal = mapOfAllMyAudiences => {
    const { open: openModal } = useModal();

    const openModalDialog = useCallback(
        async audienceName => {
            return await openModal({
                title: audienceName ? (
                    <FormattedMessage
                        id="my.audiences.delete.default.exclude.popup.title.with.audience.name"
                        defaultMessage={'Remove "{audienceName}"?'}
                        values={{ audienceName }}
                        tagName="h2"
                    />
                ) : (
                    <FormattedMessage
                        id="my.audiences.delete.default.exclude.popup.title"
                        defaultMessage="Remove Audience Segments?"
                        tagName="h2"
                    />
                ),
                content: (
                    <FormattedMessage
                        id="my.audiences.delete.default.exclude.popup.Message"
                        defaultMessage="This audience segment was previously set as a default exclusion. Removing it may <strong>impact</strong> your campaign's performance. {newline}{newline}Are you sure you want to proceed?"
                    />
                ),
                formProps: {
                    submitButtonText: (
                        <FormattedMessage id="app.actionButtons.yes.remove" defaultMessage="Yes, Remove" />
                    ),
                    cancelButtonText: <FormattedMessage id="app.actionButtons.cancel" defaultMessage="Cancel" />,
                },
            });
        },
        [openModal]
    );

    const openModalWithAudienceDetails = useCallback(
        async audience => {
            const fullAudience = mapOfAllMyAudiences[audience?.id] || {};
            if (!audience || !!fullAudience.excludeFromCampaigns) {
                return await openModalDialog(fullAudience.name);
            }
        },
        [mapOfAllMyAudiences, openModalDialog]
    );

    return { openModal: openModalWithAudienceDetails };
};
